import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavLinkComponent } from './nav-link/nav-link.component';
import { RouterModule } from '@angular/router';
import { NavigationComponent } from './navigation/navigation.component';

@NgModule({
  declarations: [NavLinkComponent, NavigationComponent],
  imports: [CommonModule, RouterModule],
  exports: [NavLinkComponent, NavigationComponent],
})
export class ComponentsModule {}
